import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';
import ProductActiveIngredientsPanel from './ProductActiveIngredientsPanel';

const fields: LookupField[] = [
  {
    key: 'rawText',
    label: 'Raw Import Text',
    required: true,
    helperText: 'Exact product text as it appears in the source file (matched case-insensitively).',
  },
  {
    key: 'productId',
    label: 'Product',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/products',
    referenceSearchable: true,
    displayKey: 'productName',
    secondaryDisplayKey: 'productActiveIngredientDetails',
    referenceSecondaryKey: 'activeIngredientDetails',
  },
];

// Admin view of ProductAlias — the "this raw import text means this Product"
// mappings the import matching service learns automatically. See
// ProductAlias.cs for why this exists: it's otherwise write-only.
const ProductAliasManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Product Map"
    icon={<LinkIcon />}
    apiPath="/api/product-aliases"
    fields={fields}
    entityLabel="Product Alias"
    softDelete={false}
    renderExtra={({ formData }) => <ProductActiveIngredientsPanel productId={formData.productId} />}
  />
);

export default ProductAliasManagement;
